export default __webpack_public_path__ + "static/media/kitchen3-afterD-480w.061b22f8.webp";